// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3kq2P","inputActions":"styles_inputActions__3nzG_","edit":"styles_edit__2j-RQ"};